import styled from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';
import { Typography } from '../../../../ui/Typography';

export const AdvertInfo = styled(FlexColumn)`
  gap: 10px;
  margin-bottom: 10px;
`;

export const AdvertInfoTitle = styled(Typography)`
  font-size: 20px;
`;

export const AdvertInfoSubtitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
